import { render } from "./SabyIntegrationSelect.vue?vue&type=template&id=0d178d5a"
import script from "./SabyIntegrationSelect.vue?vue&type=script&lang=js"
export * from "./SabyIntegrationSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__